<div class="alert-container {{ alert.type }} {{ alert.containerClass }}" [ngClass]="{ 'd-none': !alert.isActive }">
  <div class="icon">
    <span class="material-symbols-outlined"> info </span>
  </div>

  <div class="bx-content">
    <p *ngIf="alert.title" class="title">{{ alert.title }}</p>

    @if (alert.content) {
      <div class="content" [innerHTML]="alert.content"></div>
    }

    <div class="content" [ngClass]="{ 'd-none': !alert.isActive }">
      <ng-template #dynamicContainer></ng-template>
    </div>
  </div>

  <div class="bx-close">
    <button *ngIf="alert.hasCloseButton" (click)="close()">
      <span class="material-symbols-outlined"> close </span>
    </button>
  </div>
</div>
